const styles = {
  container: "max-w-screen mx-5 sm:mx-12 flex flex-col grow items-center",
  content: "max-w-7xl w-full flex flex-col grow",
};

export default styles;
